import { DASHCOLORS } from 'bd-web-components';
import styled, { css } from 'styled-components'

interface ExceptionContainerProps {
  height: number;
  margin: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`;

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`
export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const PageTitle = styled.h4`
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-top: 40px;
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin-top: 27px;
    margin-bottom: 13px;
  }
`
export const PageSubtitle = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
export const ExceptionContainer = styled.div<ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.height !== undefined && css`
    height: ${props.height}px;
  `}
  ${props => props.margin && css`
    margin-bottom: 100px;
  `}
`
export const AdvanceComponent = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`
export const StyledForm = styled.form`
  margin: 0;
  padding: 0;
`
